import Cookies from 'js-cookie';
import user from '@/user';

export default () => {
  const PARTNER_WELCOME_COOKIE = 'partnerWelcomePopup';

  const removeCookie = () => {
    let domain = window.location.hostname;
    domain = domain.substring(domain.indexOf('infolibre'));

    Cookies.remove(PARTNER_WELCOME_COOKIE, { path: '/', domain: domain });
  }

  const closeAndRemovePopup = () => {
    setTimeout(() => {
      $('body').css('overflow-y', 'auto');
    }, 1);
    $('#popup-partnerwelcome').hide(300, () => {
      $(this).remove();
    });

    removeCookie();
  }

  const removePopup = () => {
    $('#popup-partnerwelcome').remove();
  }

  const showPopup = () => {
    $('#popup-partnerwelcome-nick').text(user.nick);
    $('body').css('overflow-y', 'hidden');
    $('#popup-partnerwelcome').removeClass('d-none');
    $('#partnerWelcomeClose, #partnerWelcomeLater').off('click').click(function(e) {
      e.preventDefault();
      closeAndRemovePopup();
    });
    $(document).keyup((e) => {
      if (e.key === 'Escape') {
        closeAndRemovePopup();
      }
    });

    removeCookie();
  };

  if (
    !user.isLogged
    || !user.isPartner
    || $('#popup-partnerwelcome').length === 0
    || Cookies.get(PARTNER_WELCOME_COOKIE) === undefined
  ) {
    removePopup();
    return;
  }

  showPopup();
}
